import Vue from 'vue'
import _ from 'lodash'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import VueLocalStorage from 'vue-localstorage'
import router from './index'

Vue.use(AclInstaller);
Vue.use(VueLocalStorage);

const vue = new Vue({});

const token = vue.$localStorage.get('user');
let permissao = 'unlogged';

if (token) {
  const permissoes = token ? JSON.parse(token).perfis : [];

  if (_.filter(permissoes, { perfil_id: 1 }).length) {
    permissao = 'usuario';
  }
  if (_.filter(permissoes, { perfil_id: 2 }).length) {
    permissao = 'gestor';
  }
  if (_.filter(permissoes, { perfil_id: 3 }).length) {
    permissao = 'admin';
  }
}

export default new AclCreate({
  initial: permissao,
  notfound: '/',
  router,
  acceptLocalRules: true,
  globalRules: {
    isUnlogged: new AclRule('unlogged').generate(),
    isUser: new AclRule('usuario').or('gestor').or('admin').generate(),
    isGestor: new AclRule('gestor').or('admin').generate(),
    isAdmin: new AclRule('admin').generate(),
  }
});
